let _view_history = localStorage.getItem("view_history")
  ? JSON.parse(localStorage.getItem("view_history"))
  : [];
if (_view_history && _view_history.length > 0) {
} else {
  //hidden recent view secion
  const _section_recent_view = document.querySelector(
    ".ec-index-recent-view-section"
  );
  _section_recent_view.style.display = "none";
}
_view_history = _view_history.reverse();
console.log(_view_history);
const set_recent_view = async (list) => {
  let _recent_view_list = list;
  const _recent_viewed = document.querySelector(".index-recent-view-list");
  let _html = "";
  let _nums = 0;
  if (list && list.length > 0) {
    for (const item of list) {
      if (_nums >= 12) {
        break;
      }
      const _prodInfo = await getProductByHandle(
        item.handle.replace("/products/", "")
      );
      if (_prodInfo) {
        const _template = createTemplate(
          _prodInfo,
          item.handle.replace("/products/", "")
        );
        _html += _template;
        _nums++;
      }
    }
    _recent_viewed.innerHTML = _html;
    // var splide_rv = new Splide(".splide_recent_view", {
    //   perPage: 4,
    //   perMove: 4,
    //   gap: "35px",
    //   breakpoints: {
    //     998:{
    //       perPage: 2,
    //       perMove: 2,
    //     },
    //     640: {
    //       gap: "0px",
    //       perPage: 1,
    //       perMove: 1,
    //       autoHeight: true,
    //     },
    //   },
    // });
    // var bar_rv = splide_rv.root.querySelector(".eirv-bar");
    // // Updates the bar width whenever the carousel moves:
    // splide_rv.on("mounted move", function () {
    //   var end_rv = splide_rv.Components.Controller.getEnd() + 1;
    //   console.log(end_rv);
    //   var rate_rv = Math.min((splide_rv.index + 1) / end_rv, 1);
    //   var width_bar_rv = Math.min(1 / end_rv, 1);
    //   bar_rv.style.width = String(100 * width_bar_rv) + "%";
    //   bar_rv.style.left = String(100 * rate_rv - 100 * width_bar_rv) + "%";
    // });
    // splide_rv.mount();
  }
};
// 获取商品信息的函数
async function getProductByHandle(handle) {
  const query = `
              query($handle: String!) {
                productByHandle(handle: $handle) {
                  id
                  title
                  description
                  vendor
                  metafields(identifiers: [{namespace: "wk_custom_field", key: "cus_oiloncanvas"},{namespace: "wk_custom_field", key: "cus_size"},{namespace: "wk_custom_field", key: "cus_isquire"}]) {
                    key
                    value
                  }
                  variants(first: 5) {
                    edges {
                      node {
                        id
                        title
                        price {
                          amount
                          currencyCode
                        }
                        product {
                          id
                          featuredImage {
                            originalSrc
                            altText
                          }
                        }
                        sku
                      }
                    }
                  }
                }
              }
            `;

  const variables = {
    handle: handle,
  };

  return fetchGraphQL(query, variables)
    .then((data) => {
      const product = data.productByHandle;
      // console.log(product);
      return product;
    })
    .catch((error) => {
      console.error("Error retrieving product:", error);
    });
}
function fetchGraphQL(query, variables = {}) {
  const endpoint =
    "https://store.magnifissance.com/api/2023-07/graphql.json";
  const accessToken = "6dd485b7997c77cc4794f50f5ff2ae3b"; // 替换为您的访问令牌

  return fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": accessToken,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  })
    .then((response) => response.json())
    .then((data) => data.data)
    .catch((error) => {
      console.error("GraphQL Error:", error);
    });
}
const createTemplate = (prod, prod_handle) => {
  // console.log(prod);
  if (prod == null) {
    return "";
  }
  let _product_vendor = prod.vendor.replace(" ", "-").toLowerCase();
  let _ooc = "";
  let _size = "";
  let _isquire = "";
  if (prod.metafields && prod.metafields.length > 0) {
    for (const item of prod.metafields) {
      if (item && item.key && item.key == "cus_oiloncanvas") {
        _ooc = item.value;
      }
      if (item && item.key && item.key == "cus_size") {
        _size = item.value;
      }
      if (item && item.key && item.key == "cus_isquire") {
        _isquire = item.value;
      }
    }
  }
  let _price = "";
  if (_isquire != "Yes") {
    _price = "$ " + formatCurrency_v1(prod.variants.edges[0].node.price.amount);
  } else {
    _price = "Price upon request";
  }
  let _save = create_save(prod.id, "/products/" + prod_handle);
  let _html = `<div class="eirv-p-block">
        <div class="eirv-img">
          <div class="eirv-img-block">
          <a href="/products/${prod_handle}">
                <img src=${prod.variants.edges[0].node.product.featuredImage.originalSrc}">
                </a>
          </div>
        </div>
        <div class="eirv-b-info-warp">
        ${_save}
          <div class="eirv-b-vendor">
          <div class="vendor-txt"><a href='/pages/artists/${_product_vendor}'>${prod.vendor}</a></div>
          </div>
            
            <div class="index-prod-title"><a href="/products/${prod_handle}" class="eirv-b-title">${prod.title}</a></div>
            <div class="eirv-b-attr1">${_ooc}</div>
            <div class="eirv-b-attr2">${_size}</div>
            <div>
                <span class="money">${_price}</span>
            </div>
        </div>
      </div>
  `;
  return _html;
};

function formatCurrency_v1(num) {
  num = num.toString().replace(/\$|\,/g, "");
  if (isNaN(num)) num = "0";
  sign = num == (num = Math.abs(num));
  num = Math.floor(num * 100 + 0.50000000001);
  cents = num % 100;
  num = Math.floor(num / 100).toString();
  if (cents < 10) cents = "0" + cents;
  for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
    num =
      num.substring(0, num.length - (4 * i + 3)) +
      "," +
      num.substring(num.length - (4 * i + 3));
  return (sign ? "" : "-") + num;
}

const create_save = (id, url) => {
  let _id = id.replace("gid://shopify/Product/", "");
  return `
  <div class="add_f_btn" data-id="${_id}" data-url="${url}">
                <div class="inactive"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="圖層_1" x="0px" y="0px" viewBox="0 0 151.7 150" style="enable-background:new 0 0 151.7 150;" xml:space="preserve">
<style type="text/css">
	.st03={fill:none;stroke:currentColor;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
</style>
<path class="st0" d="M32.3,10.7C18.6,13.4,7.6,24.4,4.6,38c-2.5,11.2,0.5,21.6,6.5,29.5h-0.2l59.3,69.2c2.9,3.4,8.1,3.4,10.9,0  l59.3-69.2h-0.1c6-8,9-18.3,6.5-29.5c-3-13.6-14-24.6-27.7-27.3C96,6.1,75.7,23.7,75.7,45.9C75.7,23.6,55.4,6.1,32.3,10.7z"></path>
</svg></div>
                <div class="active"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="圖層_1" x="0px" y="0px" viewBox="0 0 151.7 150" style="enable-background:new 0 0 151.7 150;" xml:space="preserve">
<style type="text/css">
	.st0s{stroke:#000000;stroke-miterlimit:10;}
</style>
<path class="st0s" d="M32.3,10.7C18.6,13.4,7.6,24.4,4.6,38c-2.5,11.2,0.5,21.6,6.5,29.5h-0.2l59.3,69.2c2.9,3.4,8.1,3.4,10.9,0  l59.3-69.2h-0.1c6-8,9-18.3,6.5-29.5c-3-13.6-14-24.6-27.7-27.3C96,6.1,75.7,23.7,75.7,45.9C75.7,23.6,55.4,6.1,32.3,10.7z"></path>
</svg></div>
              </div>
`;
};

const r_main = async () => {
  await set_recent_view(_view_history);
  _btn_add_my_favorites = document.querySelectorAll(".add_f_btn");
  const _btn_add_my_favorites_rv = document.querySelectorAll(
    ".eirv-p-block .add_f_btn"
  );
  console.log("--->", _btn_add_my_favorites.length);
  _btn_add_my_favorites_rv.forEach(function (currentBtn) {
    currentBtn.addEventListener("click", (handleEvent) => {
      if (_login_user_) {
        console.log(currentBtn.getAttribute("data-id"));
        const _prod_handle = currentBtn
          .getAttribute("data-url")
          .replace("/products/", "");
        console.log(_prod_handle),
          update_favorites(_prod_handle),
          update_others_this_product_btn(_prod_handle);
      } else window.location.href = "/account/login";
    });
  });
  get_customer_favorites();
};

r_main();

window.addEventListener("load", function () {
  var bannerLarge = document.querySelectorAll(".banner--large");

  // 定义一个函数来设置元素高度
  function setBannerHeight() {
    for (const bb of bannerLarge) {
      console.log(window.innerWidth);
      if (window.innerHeight < 750 && window.innerWidth > 985) {
        bb.style.maxHeight = "850px";
        bb.style.height = "850px";
      } else {
        if (window.innerWidth > 985) {
          bb.style.maxHeight = "96vh";
          bb.style.height = "calc(100vh)";
        } else {
          bb.style.maxHeight = "unset";
          bb.style.height = "unset";
        }
      }
    }
  }

  // 初始化时设置元素高度
  setBannerHeight();

  // 当窗口大小改变时重新设置元素高度
  window.addEventListener("resize", setBannerHeight);
});
